/** DB revision_number 1 is the original PO (R0); 2 → R1, matching the `-R1` PO number suffix. */
export function displayPoRevisionLabel(revisionNumber?: number | null): string {
  const n = Number(revisionNumber);
  const safe = Number.isFinite(n) && n >= 1 ? Math.trunc(n) : 1;
  return `R${safe - 1}`;
}

export function isPoRevision(revisionNumber?: number | null): boolean {
  return Number(revisionNumber) > 1;
}
